import React, { forwardRef } from 'react';
const FormControlLabelText = (StyledFormControlLabelText) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledFormControlLabelText ref={ref} {...props}>
        {children}
      </StyledFormControlLabelText>);
});
export default FormControlLabelText;
